export default function about_us() {
    console.log('%c Sakurairo %c https://github.com/mirai-mamori/Sakurairo', 'background:#D05A6E;color:#fffffb', '');
    console.log(`    僕らは求めるものも
    描いてる未来も違うけれど
    手と手を取り合えたなら
    きっと笑い合える日が来るから
    %c——「ツバメ」`, 'font-style:italic');
}
